import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
import { FiltroMetaDetalhes, MetaAnualDetalhes, MetaVisaoAnualDTO } from './relatorio-meta-visao-anual';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-meta-visao-anual',
  templateUrl: './meta-visao-anual.component.html',
  styleUrls: ['./meta-visao-anual.component.scss']
})
export class MetaVisaoAnualComponent implements OnInit {
  relatorioMetaVisaoAnual: MetaVisaoAnualDTO[];

  pesquisando: boolean;
  showTable: boolean = false;

  anosLista: IdDescricao[] = [];
  anoSelecionado: number;
  
  _listaUnidades: any[] = [];
  _listaMeses: any[] = [];
  _dadosTransformados: any[] = [];

  modalDados: BsModalRef;
  modalDetalhes: MetaAnualDetalhes[] = [];
  tituloModal: string;

  constructor(
    private _relatorioService: RelatorioService,
    private _consultasService: ConsultasService,
    private _modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this._consultasService.consultar('ANOSMETA').toPromise().then(data => {
      this.anosLista = data;
      this.anoSelecionado = this.anosLista[data.length - 1].Id;
    });
  }

  pesquisar() {
    if ((this.anoSelecionado??0) == 0) {
      this.toastr.warning('Selecione um ano', 'Atenção');
      return;
    }
    this.relatorioMetaVisaoAnual = [];
    this.pesquisando = true;
    this._relatorioService.obterRelatorioVisaoAnual(
      Number.parseInt(this.anosLista.filter(ano => ano.Id === this.anoSelecionado)[0].Descricao)
    ).toPromise().then(
      (dadosRelatorio) => {
        if (dadosRelatorio.length === 0) {
          this.relatorioMetaVisaoAnual = [];
          this.toastr.info("Busca não encontrou resultados");
          //this.pesquisando = false;
          this.showTable = false;
          return;
        } 
        
        this.relatorioMetaVisaoAnual = dadosRelatorio;
        if(this.relatorioMetaVisaoAnual.length >= 2) {
          this.relatorioMetaVisaoAnual.push(_calculaBalancoGeral());
        }
        this.alteraEstruturaDadosParaTabela();
        //this.pesquisando = false;
        this.showTable = true;

        function _calculaBalancoGeral() : MetaVisaoAnualDTO {
          var itemGeral: MetaVisaoAnualDTO = {
              UnidadeId: 0,
              UnidadeDescricao: 'GERAL',
              JaneiroMeta: dadosRelatorio.reduce((total, x) => total + x.JaneiroMeta, 0),
              JaneiroQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.JaneiroQuantidadeProcessos, 0),
              FevereiroMeta: dadosRelatorio.reduce((total, x) => total + x.FevereiroMeta, 0),
              FevereiroQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.FevereiroQuantidadeProcessos, 0),
              MarcoMeta: dadosRelatorio.reduce((total, x) => total + x.MarcoMeta, 0),
              MarcoQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.MarcoQuantidadeProcessos, 0),
              AbrilMeta: dadosRelatorio.reduce((total, x) => total + x.AbrilMeta, 0),
              AbrilQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.AbrilQuantidadeProcessos, 0),
              MaioMeta: dadosRelatorio.reduce((total, x) => total + x.MaioMeta, 0),
              MaioQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.MaioQuantidadeProcessos, 0),
              JunhoMeta: dadosRelatorio.reduce((total, x) => total + x.JunhoMeta, 0),
              JunhoQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.JunhoQuantidadeProcessos, 0),
              JulhoMeta: dadosRelatorio.reduce((total, x) => total + x.JulhoMeta, 0),
              JulhoQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.JulhoQuantidadeProcessos, 0),
              AgostoMeta: dadosRelatorio.reduce((total, x) => total + x.AgostoMeta, 0),
              AgostoQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.AgostoQuantidadeProcessos, 0),
              SetembroMeta: dadosRelatorio.reduce((total, x) => total + x.SetembroMeta, 0),
              SetembroQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.SetembroQuantidadeProcessos, 0),
              OutubroMeta: dadosRelatorio.reduce((total, x) => total + x.OutubroMeta, 0),
              OutubroQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.OutubroQuantidadeProcessos, 0),
              NovembroMeta: dadosRelatorio.reduce((total, x) => total + x.NovembroMeta, 0),
              NovembroQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.NovembroQuantidadeProcessos, 0),
              DezembroMeta: dadosRelatorio.reduce((total, x) => total + x.DezembroMeta, 0),
              DezembroQuantidadeProcessos: dadosRelatorio.reduce((total, x) => total + x.DezembroQuantidadeProcessos, 0),
              TotalMeta: dadosRelatorio.reduce((total, x) => total + x.TotalMeta, 0),
              TotalQuantidadeProcesso: dadosRelatorio.reduce((total, x) => total + x.TotalQuantidadeProcesso, 0)
            };

            return itemGeral;
        }
      }, 
      erro => this.toastr.warning("Realize a pesquisa novamente.")
    ).finally(() => this.pesquisando = false);
  }

  @ViewChild('relatorioAnual') relatorio: ElementRef;
  private alteraEstruturaDadosParaTabela() {
    const dataByUnit = {};

    // loop over the original data and store it in the object by unit
    this.relatorioMetaVisaoAnual.forEach(item => {
      const unit = item.UnidadeDescricao;
      dataByUnit[unit] = {
        Janeiro: {
          QuantidadeProcessos: `${item.JaneiroQuantidadeProcessos}`, 
          Meta: `${item.JaneiroMeta}`},
        Fevereiro: {
          QuantidadeProcessos: `${item.FevereiroQuantidadeProcessos}`, 
          Meta: `${item.FevereiroMeta}`},
        Março: {
          QuantidadeProcessos: `${item.MarcoQuantidadeProcessos}`, 
          Meta: `${item.MarcoMeta}`},
        Abril: {
          QuantidadeProcessos: `${item.AbrilQuantidadeProcessos}`, 
          Meta: `${item.AbrilMeta}`},
        Maio: {
          QuantidadeProcessos: `${item.MaioQuantidadeProcessos}`, 
          Meta: `${item.MaioMeta}`},
        Junho: {
          QuantidadeProcessos: `${item.JunhoQuantidadeProcessos}`, 
          Meta: `${item.JunhoMeta}`},
        Julho: {
          QuantidadeProcessos: `${item.JulhoQuantidadeProcessos}`, 
          Meta: `${item.JulhoMeta}`},
        Agosto: {
          QuantidadeProcessos: `${item.AgostoQuantidadeProcessos}`, 
          Meta: `${item.AgostoMeta}`},
        Setembro: {
          QuantidadeProcessos: `${item.SetembroQuantidadeProcessos}`, 
          Meta: `${item.SetembroMeta}`},
        Outubro: {
          QuantidadeProcessos: `${item.OutubroQuantidadeProcessos}`, 
          Meta: `${item.OutubroMeta}`},
        Novembro: {
          QuantidadeProcessos: `${item.NovembroQuantidadeProcessos}`, 
          Meta: `${item.NovembroMeta}`},
        Dezembro: {
          QuantidadeProcessos: `${item.DezembroQuantidadeProcessos}`, 
          Meta: `${item.DezembroMeta}`},
        Total: {
          QuantidadeProcessos: `${item.TotalQuantidadeProcesso}`, 
          Meta: `${item.TotalMeta}`},
        Diferença: {
          QuantidadeProcessos: `${item.TotalQuantidadeProcesso - item.TotalMeta}`, 
          Meta: `${0}`}
      };
    });
    try {
      this._listaUnidades = [];
      this._listaUnidades = Object.keys(dataByUnit);

      this._listaMeses = Object.keys(dataByUnit[this._listaUnidades[0]]);
    } catch (error) {
    }


    this._dadosTransformados = this._listaMeses.map(month => this._listaUnidades.reduce((acc, unit) => {
      acc[unit] = dataByUnit[unit][month];
      return acc;
    }, {})
    );
  }

  abrirModalDados(modalReferencia: TemplateRef<any>, mesModal: string, unidadeModal: string) {
    if(mesModal == 'Total' || mesModal == 'Diferença') {
      return;
    }

    let anoString = this.anosLista.filter(x => x.Id === this.anoSelecionado)[0].Descricao;
    this.tituloModal = `${unidadeModal}(${mesModal}/${anoString})`;

    // buscar dados
    let filtrosDetalhes: FiltroMetaDetalhes = new FiltroMetaDetalhes();
    filtrosDetalhes = {
      UnidadeId: this.relatorioMetaVisaoAnual.filter(item => item.UnidadeDescricao == unidadeModal)[0].UnidadeId,
      MesString: mesModal,
      AnoString: anoString
    }


    this._relatorioService.obterDetalhesVisaoAnual(filtrosDetalhes).toPromise().then(
      (dados : MetaAnualDetalhes[]) => {
        this.modalDetalhes.length = 0;
        this.modalDetalhes.push(...dados);
        
        this.modalDados = this._modalService.show(modalReferencia);

      }
    );
  }

  fecharModalDados() {
    this.modalDados.hide();
  }

  public imprimir() {
    let conteudo = document.getElementById("metasvisaoanual").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório de Metas (Visão Anual)", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();
    
    obtemDescricaoAdicionaMap('Ano', this.anosLista, this.anoSelecionado);
    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
